import { combineReducers } from '@reduxjs/toolkit';
import authReducer from '@/features/auth/store/authSlice';
import errorReducer from './slices/errorSlice';

export const rootReducer = combineReducers({
  auth: authReducer,
  error: errorReducer
});

export type RootState = ReturnType<typeof rootReducer>;
